import React, { Component } from 'react';
import NavbarLogo from '../NavbarLogo/NavbarLogo';
require('./Navbar.scss');

class Navbar extends Component {
    componentDidMount() {
        this.handleNavbarBackgroundOnScroll();
    }
    handleNavbarBackgroundOnScroll() {
        let NavbarElement = document.querySelectorAll('.Navbar')[0];
        let NavbarElementHeight = NavbarElement.offsetHeight * 0.25;
        let doc = document.documentElement;
        window.addEventListener('scroll', (e) => {
            var docViewTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
            if(docViewTop > NavbarElementHeight) {
                NavbarElement.classList.add('Section--accented');
            } else {
                NavbarElement.classList.remove('Section--accented');
            }
        });
    }
    render() {
        return (
            <div id="navbar" className="Navbar">
                <div className="container">
                    <div className="row Navbar-row flex-items-xs-middle">
                        <div className="col-xs text-xs-left">
                            <NavbarLogo />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Navbar.contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.object
};

export default Navbar;



/** WEBPACK FOOTER **
 ** ./src/components/Navbar/Navbar.js
 **/